import { AxiosError } from 'axios';
import { get } from '@/utils';
import { ISubscribedAdministration } from './types';

type SubscribedAdministrationsResponse = {
	items: ISubscribedAdministration[];
	pageNumber: number;
	totalPages: number;
	totalCount: number;
	orderBy: string | null;
	ascending: boolean;
	hasPreviousPage: boolean;
	hasNextPage: boolean;
};

async function fetchSubscribedAdministrations(
	userId: number | string,
	page: number,
	items: number,
	onResponse?: (page: number, items: number) => void
): Promise<ISubscribedAdministration[]> {
	try {
		const res = await get(
			`api/users/${userId}/subscribed-administrations?PageNumber=${page + 1}&PageSize=${items}`
		);
		const data = res.data as SubscribedAdministrationsResponse;
		onResponse?.(data.totalPages || 1, data.totalCount || 0);
		return data.items || [];
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reușit să accesăm administrațiile abonate.');
	}
}

export { fetchSubscribedAdministrations };
